import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, FloatButton, Row, Table, Tabs, Tag } from "antd";
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import ModalTextForm from "../../components/modal/ModalTextForm";
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from "../../helpers/common";
import { NhanVienTheoToBan, ToBan } from "../../models/toban/ToBan";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { layChiTiet, xoaToBan } from "../../services/toban";
import { urlAdmin } from '../../constants';

const XemToBan = () => {
    let navigate = useNavigate();
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    const [loading, setLoading] = useState(false);
    const [dsNhanVien, setDsNhanVien] = useState<Array<NhanVienTheoToBan>>([]);
    const [data, setData] = useState<ToBan>(new ToBan);
    const menu: any = menuHelper.checkMultiPermission([Links.ToBan.ChiTiet]);
    const [openModalXoa, setOpenModalXoa] = useState(false);

    const layCT = async (id: number) => {
        setLoading(true);
        try {
            if (id > 0) {
                var data = await layChiTiet(id);
                setData(data);
                setDsNhanVien(data.dsNhanVien);
                setLoading(false);
            }
        }
        catch (error: any) {
            toast.error("Tổ ban không tồn tại!");
            setLoading(false);
        }
    }

    const xoa = async () => {
        try {
            setLoading(true);
            await xoaToBan(parseInt(id));
            setLoading(false);
            setOpenModalXoa(false);
            toast.success('Xóa tổ ban thành công');
            navigate(Links.ToBan.DanhSach);
        }
        catch (error: any) {
            setLoading(false);
            toast.error('Xóa tổ ban không thành công! Vui lòng thử lại.');
        };
    };

    useEffect(() => {
        setLoading(true);
        if (parseInt(id) > 0) {
            layCT(parseInt(id));
        }
        setLoading(false);
    }, []);

    if (loading) {
        return <LoadingDetailPage title="Tổ ban" />
    }

    return (
        <section style={{ paddingBottom: "60px" }}>
            <ContentHeader title="Tổ ban" />
            {openModalXoa && <ModalTextForm show={openModalXoa}
                title="Xoá tổ ban"
                handleClose={() => setOpenModalXoa(false)}
                handleSave={() => xoa()}>
                Bạn có đồng ý xóa tổ ban này không?
            </ModalTextForm>}
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: 'Thông tin tổ ban',
                                children:
                                    <div className="card pt-3 pb-2">
                                        <div className="tab-content" style={{ marginLeft: "20px" }}>
                                            <Row>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Tên tổ ban</div>
                                                        <label>{data?.ten}</label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Ngày bắt đầu</div>
                                                        <label>{dateCommon.formatDate(data?.ngayBatDau)}</label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Số quyết định</div>
                                                        <label>{data?.soQuyetDinh}</label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Ngày kết thúc</div>
                                                        <label>{dateCommon.formatDate(data?.ngayKetThuc)}</label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="mb-1">
                                                        <div>Ngày ký quyết định</div>
                                                        <label>{dateCommon.formatDate(data?.ngayKyQuyetDinh)} </label>
                                                    </div>
                                                    <div className="mb-1">
                                                        <div>Trạng thái</div>
                                                        <label><Tag color={data?.trangThai == 1 ? "green" : "red"}>{data?.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <div className="mb-1">
                                                        <div>Mô tả</div>
                                                        <label>{data?.moTa}</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Col span="24" className="form-group row">
                                                <Col span="24" className="form-group">
                                                    <div>File đính kèm</div>
                                                    <Table
                                                        locale={{ emptyText: "Không có dữ liệu" }}
                                                        pagination={false} size='small'
                                                        dataSource={(data?.dsTaiLieu || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                                                    >
                                                        <Column
                                                            title="STT"
                                                            key="STT"
                                                            align="center"
                                                            render={(value, record, index) =>
                                                            (
                                                                <>
                                                                    {index + 1}
                                                                </>
                                                            )
                                                            }
                                                        />
                                                        <Column title="Tên tài liệu" key="tenTep" render={(value, record, index) => (
                                                            <p>{value?.tenTep?.replace(/^.*[\\/]/, '')}</p>
                                                        )} />
                                                        <Column title="Xem" key="Xem"
                                                            render={(value, record, index) =>
                                                            (
                                                                <>
                                                                    <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Xem" onClick={() => {
                                                                        window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')
                                                                    }}><i className="fa fa-eye mr-2" />Xem</Button>
                                                                </>
                                                            )
                                                            }
                                                        />
                                                        <Column title="Tải xuống" key="Xem"
                                                            render={(value, record, index) =>
                                                            (
                                                                <>
                                                                    <a href={urlAdmin + value?.duongDan?.replace(/\\/g, "/")} download>
                                                                        <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Tải xuống">
                                                                            <i className="fa fa-download mr-2" />Tải xuống
                                                                        </Button>
                                                                    </a>
                                                                </>
                                                            )
                                                            }
                                                        />
                                                    </Table>
                                                </Col>
                                            </Col>
                                        </div>
                                    </div>
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Danh sách nhân viên',
                                    children:
                                        <Table
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            dataSource={dsNhanVien}
                                            pagination={false}
                                            rowKey="id"
                                        >
                                            <Column
                                                title="STT"
                                                key="STT"
                                                width="5%"
                                                render={(value, record, index) =>
                                                (
                                                    <>
                                                        {index + 1}
                                                    </>
                                                )}
                                            />
                                            <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                            <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                            <Column title="Chức danh" dataIndex="chucDanh" key="chucDanh" />
                                        </Table>
                                },
                            ]}>
                        </Tabs>
                        {menu[Links.ToBan.ChiTiet] &&
                            <Row className="mt-1 mb-1">
                                <Col span="24">
                                    <FloatButton.Group
                                        trigger="hover"
                                        type="primary"
                                        style={{ right: 50, bottom: 80 }}
                                    >
                                        <FloatButton
                                            tooltip="Chỉnh sửa thông tin tổ ban"
                                            className="hrm-btn-warning"
                                            icon={<EditOutlined rev="" />}
                                            onClick={() => {
                                                navigate(Links.ToBan.ChiTiet + "?id=" + id);
                                            }}
                                        />
                                        <FloatButton
                                            tooltip="Xóa tổ ban"
                                            className="hrm-btn-delete"
                                            icon={<DeleteOutlined rev="" />}
                                            onClick={() => setOpenModalXoa(true)}
                                        />

                                    </FloatButton.Group>
                                </Col>
                            </Row>}
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default XemToBan;